import {WixSdk} from '@wix/js-sdk-wrapper';
import {getBaseUrl} from '../../utils/env/base-url';
import {noop} from '../../utils/functions';
import {openPopup} from '../../utils/wix-sdk';
import {isInEditor, isInPreview} from '../new/viewMode';

export const filterInEditor: <T extends (...args: Z) => void, Z extends any[]>(
  onDisable?: () => void,
) => (fn: T) => T =
  (onDisable = noop) =>
  (fn: Function) => {
    return ((...args: any) => {
      if (isInEditor() || isInPreview()) {
        onDisable();
        return;
      }
      fn(...args);
    }) as any;
  };

export const disableInEditor = filterInEditor(showFeatureDisabledPopup);

export function showFeatureDisabledPopup() {
  const modalPath = `${getBaseUrl()}widget-feature-disabled.html`;
  openPopup(modalPath, '100%', '100%', noop, WixSdk.Theme.BARE);
}
